import CharactersPage from './CharactersPage';
export default CharactersPage;
